import React, { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";

import ContactoForm from "../ContactoForm/ContactoForm";

const Contacto = () => {

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });

    const { t } = useTranslation();

    return(
        <section>
            <div className="contacto-info">
                <h1>{t("contacto.h1")}</h1>
                <img src="../../assets/img/logo.webp" alt="YASKIA" title="YASKIA"/>
            </div>
            <ContactoForm />
            <div className="contacto-adress">
                <article>
                    San Martín 612, Trelew, Chubut
                    <br/><br/>
                    <a href="mailto:yasminabdala@yaskia.com" target="_BLANK">yasminabdala@yaskia.com</a>
                    {/* <br/><br/>
                    <a href="tel:+5492804828528">280 482 8528</a> */}
                </article>
            </div>
        </section>
    )
}

export default Contacto